import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import './panel-subnavigation.scss';

class PanelSubnavigation extends PureComponent {
  render() {
    return (
      <div className="panel-subnavigation">
        <Link
          to={this.props.program}
          className="btn btn-flex solid-white"
          onClick={this.props.onCloseClick}
        >
          <span>
            <em>Подробнее<span className="icon">→</span></em>
            Описание услуги
          </span>
        </Link>

        <h3>Узнайте больше <br/>o наших проектах</h3>

        <ul>
          {this.props.links.map((tab, key) =>
            <li key={key}>
              <Link
                to={tab.pathname}
                dangerouslySetInnerHTML={{ __html: tab.title}}
                onClick={this.props.onCloseClick}
              />
            </li>
          )}
        </ul>
      </div>
    );
  }
}

PanelSubnavigation.propTypes = {
  program: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.object),
  onCloseClick: PropTypes.func
};

export default PanelSubnavigation;



// WEBPACK FOOTER //
// ./src/components/SuccessStory/PanelSubnavigation.js